import React from 'react'
import Image from '../../../components/image'
import Modal from '../../../components/modal'
import Checkmark from '../../../components/svg/checkmark'

function MembershipModal({ onClose, membership }) {
  return (
    <Modal onClose={onClose}>
      <div className='wrapper'>
        {membership?.programLogo ? (
          <div className='img'>
            <Image
              src={membership.programLogo}
              alt={'Program logo'}
              width='359'
              height='96'
              folder='benefitsProgramLogoImages'
            />
          </div>
        ) : null}

        <h2 className='heading'>Member Benefits</h2>
        <div className='list-of-benefits'>
          <div className='benefit'>
            <span className='pointer'>
              <Checkmark width='20' height='20' fill={'var(--success-color)'} />
              <span className='description'>Exclusive Warranty</span>
            </span>
            <span className='push'>
              <a href={membership.programUrl} target='_blank' rel='nofollow noopener noreferrer'>
                Details
              </a>
            </span>
          </div>
          <div className='benefit'>
            <div className='pointer'>
              <Checkmark width='20' height='20' fill={'var(--success-color)'} />
              <span className='description'>Payment Protection</span>
            </div>
            <span className='push'>
              <a href={membership.programUrl} target='_blank' rel='nofollow noopener noreferrer'>
                Details
              </a>
            </span>
          </div>
          <div className='benefit'>
            <div className='pointer'>
              <Checkmark width='20' height='20' fill={'var(--success-color)'} />
              <span className='description'>Market Pricing</span>
            </div>
            <span className='push'>
              <a href={membership.programUrl} target='_blank' rel='nofollow noopener noreferrer'>
                Details
              </a>
            </span>
          </div>
          <div className='benefit'>
            <div className='pointer'>
              <Checkmark width='20' height='20' fill={'var(--success-color)'} />
              <span className='description'>Exclusive Inventory</span>
            </div>
            <span className='push'>
              <a href={membership.programUrl} target='_blank' rel='nofollow noopener noreferrer'>
                Details
              </a>
            </span>
          </div>
        </div>
      </div>
      <style jsx>{`
        .img {
          text-align: center;
          padding: 2rem 0 0 0;
        }
        .wrapper {
          background-color: white;
        }
        .heading {
          font-size: 2rem;
          text-align: center;
          margin-bottom: 1rem;
        }
        .list-of-benefits {
          padding: 0rem 2rem;
        }
        .benefit {
          border-bottom: 0.1rem solid var(--separator-line-color);
          font-size: 1.5rem;
          display: flex;
          justify-content: space-between;
          padding: 1.5rem 0rem;
        }
        .pointer {
          white-space: nowrap;
        }
        .push {
          margin-left: auto;
          color: var(--primary-color);
        }
        .description {
          margin-left: 1rem;
          max-width: 60rem;
          margin-right: 2rem;
          line-height: 20px;
          vertical-align: top;
        }
      `}</style>
    </Modal>
  )
}

export default MembershipModal
